module.exports = __webpack_public_path__ + "static/media/live14_06_2025.323bf9ae.jpg";